/**
 * @Description 选址详情-集客点列表
 */
import V2Title from '@/common/components/Feedback/V2Title';
import styles from './index.module.less';
import GatherItem from './GatherItem';
import { useState } from 'react';
import PlanSpotDetail from '../PlanSpotDetail';
import V2Drawer from '@/common/components/Feedback/V2Drawer';
// import PlanSpotDetail from '@/common/components/business/ExpandStore/PlanSpotDetail';

const GatherList = ({
  gatherList,
  clusterId,
  detail
}) => {
  const [detailDrawer, setDetailDrawer] = useState({
    visible: false,
    value: null,
  });// 点击的时候设置id,等拿到数据后再设置visible为true（无法直接从对应的点击元素中拿到所有的数据）

  return <div>
    {gatherList?.length
      ? <div className={styles.gatherListCon}>
        <V2Title divider type='H2' text={`集客点`}/>
        {gatherList?.map(item => {
          return <GatherItem
            key={item.id}
            clusterId={clusterId}
            detail={item}
            setDetailDrawer={setDetailDrawer}
            polygonInfo={{
              radius: detail?.radius,
              polygon: detail?.polygon
            }}
          />;
        })}
      </div>
      : <></>}
    <V2Drawer
      open={detailDrawer.visible}
      onClose={() => setDetailDrawer({
        visible: false,
        value: null,
        // id: null
      })}
      destroyOnClose
    >
      {detailDrawer.visible ? <PlanSpotDetail
        aprDetail={null}
        detail={detailDrawer.value}
      /> : <></>}
    </V2Drawer>
  </div>;
};
export default GatherList;
